import { render, staticRenderFns } from "./callbackTaskByLaws.vue?vue&type=template&id=1a8add1e&scoped=true&"
import script from "./callbackTaskByLaws.vue?vue&type=script&lang=js&"
export * from "./callbackTaskByLaws.vue?vue&type=script&lang=js&"
import style0 from "./callbackTaskByLaws.vue?vue&type=style&index=0&id=1a8add1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8add1e",
  null
  
)

export default component.exports